var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "display-2" }, [
          _vm._v(_vm._s(_vm.$t("pages.errauth.lbl_head"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lead" }, [
          _vm._v(_vm._s(_vm.$t("pages.errauth.lbl_body"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "button",
            {
              staticClass: "btn btn-light",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.fnNavTo("/landing")
                },
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("common.btn_ok")) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", [
          _vm._v(
            "Expired: " + _vm._s(_vm.$store.getters.isAuthenticatedExpired)
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }